import { createFileRoute } from '@tanstack/react-router';

type Search = {
  mode?: string;
  comparingLocations?: boolean;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/analytics/communication')({
  validateSearch: (search: Search) => {
    return {
      mode: search.mode,
      comparingLocations: search.comparingLocations,
    };
  },
});
